function MentionsInput({
  top3Inputs,
  selectedIndex,
  selectMention,
}: {
  top3Inputs: string[];
  selectedIndex: number;
  selectMention: (a: string) => void;
}) {
  const selectedMention = top3Inputs[selectedIndex];

  if (!selectedMention) {
    return null;
  }
  return (
    <ul className="chat-input-select-list" data-testid="mention-input">
      {top3Inputs.map((name: string, index: number) => (
        <li
          key={name}
          data-testid="mention-input-item"
          data-selected={index === selectedIndex}
          onClick={() => {
            selectMention(name);
          }}
        >
          <span className="chat-input-complete">{name}</span>
        </li>
      ))}
    </ul>
  );
}

export { MentionsInput };
